export interface GetReservesRequest {
  bibliographyRealId: number
}

export function GetReservesRequestToJSON(value: GetReservesRequest): any {
  return {
    bibliography_real_id:
      value.bibliographyRealId !== 0 ? value.bibliographyRealId : undefined
  }
}
